"use client";

import Link from "next/link";
import MuiLink from "@mui/material/Link";
import { getUrls } from "@portal/app/_common/lib/urls";
import {
  type VocationIndustry,
  VocationIndustryToName,
} from "@portal/app/_common/types/vocationIndustry";

interface IndustryExploreLinkProps {
  industry?: VocationIndustry;
}

/**
 * Sub-CTA shown on Screens B and C: "Explore other {industry} programs".
 * Falls back to "Explore other programs" when the industry isn't known.
 */
export const IndustryExploreLink = ({ industry }: IndustryExploreLinkProps) => {
  // Skip the industry suffix for the "OTHER" bucket — "Explore other other
  // programs" reads as a typo. Same fallback applies when industry is missing.
  const useGeneric = !industry || industry === "OTHER";
  const text = useGeneric
    ? "Explore other programs"
    : `Explore other ${VocationIndustryToName[industry].toLowerCase()} programs`;
  const href = useGeneric
    ? getUrls().Explore()
    : getUrls().DreamSearch({ industry, zip: undefined });

  return (
    <Link href={href} passHref legacyBehavior>
      <MuiLink
        data-testid="success-industry-explore-link"
        underline="always"
        sx={{ fontWeight: 600 }}
      >
        {text}
      </MuiLink>
    </Link>
  );
};
